import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BellIcon, HomeIcon, IdCardIcon, ScrollTextIcon, Trash2Icon, UserRoundIcon } from 'lucide-react';
import { espaceNav, type EspaceNavItem } from '../../data/espace';
import { useEspace } from '../../contexts/EspaceContext';
const icons: Record<EspaceNavItem['icon'], typeof HomeIcon> = {
  home: HomeIcon,
  card: IdCardIcon,
  profile: UserRoundIcon,
  bell: BellIcon,
  trash: Trash2Icon,
  request: ScrollTextIcon
};
export function EspaceSidebar() {
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const {
    exitEspace
  } = useEspace();
  const activeId = espaceNav.find(item => item.to === '/mon-espace' ? pathname === '/mon-espace' : pathname.startsWith(item.to))?.id;
  const leave = () => {
    exitEspace();
    navigate('/');
  };
  return <aside aria-label="Navigation de mon espace" className="hidden w-[268px] shrink-0 flex-col bg-ville-navy lg:flex" data-id="element-1191" data-mp="g5uswtorzd9j">
      <div className="px-7 pb-6 pt-8" data-id="element-1192" data-mp="187kda4vfv1ov">
        <p className="text-lg font-extrabold tracking-tight text-white" data-id="element-1193" data-mp="184ensoiwdxsm">Mon espace</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-1194" data-mp="136d7gbcuwcku">Votre espace citoyen</p>
      </div>

      <nav className="px-3 pb-8" data-id="element-1195" data-mp="y93gusdqduvf">
        <ul data-id="element-1196" data-mp="u6zu37lm33uu">
          {espaceNav.slice(0, 3).map(item => <li key={item.id} data-id="element-1197" data-mp="u8krd4zb90we">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1198" data-mp="1qx94bmw65xyy" />
            </li>)}
        </ul>

        <hr className="my-4 border-white/15" data-id="element-1199" data-mp="1lyfr7vkso8zb" />

        <ul data-id="element-1200" data-mp="1lypidmhksm6l">
          {espaceNav.slice(3).map(item => <li key={item.id} data-id="element-1201" data-mp="1h6xlyvbqnm8j">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1202" data-mp="1h64nehmxo31h" />
            </li>)}
        </ul>
      </nav>

      <button type="button" onClick={leave} className="mt-auto flex items-center gap-2 px-7 pb-8 text-sm font-semibold text-white/60 transition-colors duration-150 ease-ville hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1203" data-mp="1d3rmc6j4stb1">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1204" data-mp="309nccxc4svi" />
        Quitter mon espace
      </button>
    </aside>;
}
function SidebarLink({
  item,
  active
}: {
  item: EspaceNavItem;
  active: boolean;
}) {
  const Icon = icons[item.icon];
  return <Link to={item.to} aria-current={active ? 'page' : undefined} className={`flex items-center gap-3.5 rounded-xl px-4 py-3 text-[15px] font-semibold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white/10 text-white' : 'text-white/75 hover:bg-white/5 hover:text-white'}`} data-id="element-1205" data-mp="3udnhf2ozdghv">
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-1206" data-mp="3bf1fxmpjxndf" />
      {item.label}
    </Link>;
}